var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasForeignLists
    ? _c("div", { staticClass: "lastOpenedWishlists" }, [
        _c("div", { staticClass: "modal-title mb-2" }, [
          _vm._v("\n    Ihre letzten Besuche auf geteilten Listen:\n  "),
        ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.filteredGuestLists, function (list, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                {
                  class: "wishlist_design_" + list.colorScheme,
                  attrs: { href: "/wunschliste/" + list.accessCode + "/" },
                },
                [_vm._v(_vm._s(list.name))]
              ),
            ])
          }),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }